import { View } from 'es6/components/view'
import { Defaults } from 'es-decorators'
import $ from 'init/jquery'
import { Popup } from 'es6/libs/popup'
import Backbone from 'init/backbone'
import { getTemplate } from 'helpers/template-helper'
import { format } from 'helpers/declination-helper'

/**
 * Вид для меню в шапке корзины / избранного / каталога.
 */
@Defaults({
  events: {
    'change #c12345': 'toggleCheckbox',
    'click [data-action="wish"]': 'wish',
    'click [data-action="remove-from-collection"]': 'removeChecked',
    'click [data-action="mass-add-to-cart"]': 'addToCart',
    'click .js-toggle-filters': 'toggleFilters',
    'click .js-select-actions-toggle': 'toggleSelectActions',
    'click .js-close-select-actions': 'toggleSelectActions',
  },
  selectActionsIsOpen: false,
  additionalOptions: ['mainWindow', 'cart', 'createNotification', 'wishCollection'],
  successNotificationTemplateId: '#success-notification',
  successNotificationTemplate: null,
  notificationTemplates: null,
})
export class GridHeaderView extends View {
  /**
   * @inheritDoc
   */
  beforeRun () {
    this.$('#c12345 + .js-checkbox-opener').addClass('js-checkbox-opener')
    this.$('.catalog-filter__inner .button').removeClass('button_disabled')
  }

  /**
   * @inheritDoc
   */
  run () {
    this.notificationTemplates = {
      cart: getTemplate('#success-notification-inner'),
      wish: getTemplate('#restore-notification-inner'),
    }
    this.initPopup()
    let that = this,
      $checkbox = this.$('#c12345'),
      popup = $('.js-checkbox-popup')
    popup.find('[data-action="check"]').on('click', function () {
      $checkbox.prop('checked', true)
      that.trigger('checkboxes-add')
    })
    popup.find('[data-action="uncheck"]').on('click', function () {
      $checkbox.prop('checked', false)
      that.trigger('checkboxes-remove')
    })
    this.$selectedFiltersQty = this.$('.js-selected-filters-qty')
    this.$toggleFiltersBtn = this.$('.js-toggle-filters')
    this.$selectActionsToggle = this.$('.js-select-actions-toggle')
    this.updateFilterButton()
    this.listenToOnce(this.chosenFilters, 'has-chosen-filters', this.updateFilterButton)
    if (this.createNotification) {
      this.listenTo(this.cart, 'addedCartByArticle', this.pushNotification.bind(this, 'cart'))
      this.listenTo(this.collection, 'removeCheckedFromWish', this.pushNotification.bind(this, 'wish'))
    }
    this.successNotificationTemplate = getTemplate(this.successNotificationTemplateId)
  }

  /**
   * Отправляет оповещение.
   * @param {string} titleType Тип тайтла.
   * @param {number} deletedWishItemsLength Количество удалённых товаров.
   * @param {Array} deletedWishItemsIds Идентификаторы удалённых товаров.
   */
  pushNotification (titleType, deletedWishItemsLength, deletedWishItemsIds) {
    const title = this.notificationTemplates[titleType]({
      count: deletedWishItemsLength,
      unit: format(deletedWishItemsLength, ['товар', 'товара', 'товаров']),
      deleteText: format(deletedWishItemsLength, ['Удалён', 'Удалено', 'Удалено']),
    })
    this.createNotification(
      this.successNotificationTemplate({ title, description: null }),
      false,
      5000,
      {
        'click .js-restore-wish': () => this.addToWishById(deletedWishItemsIds),
      }
    )
  }

  /**
   * Добавляет товары по модификаторам.
   * @param {Array} itemIds Идентификаторы товаров.
   */
  addToWishById (itemIds) {
    if (this.wishCollection) {
      this.listenToOnce(this.wishCollection, 'update', () => {
        this.collection.loadFilters = true
        // Таймаут - беку нужно время для репликации(если не ждать, товары могут не вернуться на гет).
        setTimeout(() => this.collection.fetch(), 500)
      })
      this.wishCollection.addByItemIds(itemIds)
    }
  }

  /**
   * Устанавливает кол-во выбранных товаров
   * @param {number} length Количество выбранных товаров
   */
  setSelectedItemsLength (length) {
    let selectedText = 'Выберите товары'
    if (length > 0) {
      selectedText = `${format(length, ['Выбран', 'Выбрано', 'Выбрано'])} ${length} 
      ${format(length, ['товар', 'товара', 'товаров'])}`
    }
    this.$('.indication').text(selectedText)
  }

  /**
   * Переключает видимость элементов управления выделенных товаров
   * @param {(Event|null)} event Событие
   * @param {boolean} [isOpen] Признак открыт закрыт элемент.
   */
  toggleSelectActions (event, isOpen = !this.selectActionsIsOpen) {
    this.trigger('checkboxes-remove')
    this.$('#c12345').prop('checked', false)
    this.$el.toggleClass('actions-opened', isOpen)
    this.$selectActionsToggle.text(isOpen ? 'Отменить' : 'Выбрать')
    if (this.mainWindow) {
      let action = isOpen ? this.listenTo : this.stopListening
      action(this.mainWindow, 'window.scroll', this.handleScroll.bind(this))
      !isOpen && setTimeout(() => this.toggleFixedPositionItemsActions(false), 300)
    }
    this.selectActionsIsOpen = isOpen
  }

  /**
   * Обработчик скролла.
   */
  handleScroll () {
    const boundClientRect = this.el.getBoundingClientRect(),
      intervalToViewportTop = boundClientRect.top + boundClientRect.height
    this.toggleFixedPositionItemsActions(intervalToViewportTop < 0)
  }

  /**
   * Переключает позиционирование блока управления выделенных товаров.
   * @param {boolean} isFixed Признак фиксирован ли блок.
   */
  toggleFixedPositionItemsActions (isFixed) {
    this.$('.items-actions-wrap').toggleClass('fixed', isFixed)
  }

  /**
   * Обрабатывает клик на чекбокс в шапке списка товаров.
   */
  toggleCheckbox () {
    let $checkbox = this.$('#c12345')
    if ($checkbox.prop('checked')) {
      this.updateButtons(true)
      this.trigger('checkboxes-add')
    } else {
      this.trigger('checkboxes-remove')
      this.updateButtons(false)
    }
  }

  /**
   * Обновляет состояние кнопок в шапке списка товаров.
   *
   * @param {boolean} enable
   */
  updateButtons (enable) {
    this.$('button.js-disable').prop('disabled', !enable)
    this.updateFilterButton()
  }

  /**
   * Обновление кнопки фильтров
   */
  updateFilterButton () {
    if (this.$toggleFiltersBtn.length) {
      this.stopListening(this.chosenFilters, 'has-chosen-filters', this.updateFilterButton)
      const shouldFilterBeAlwaysVisible = this.collection.viewtype === 'list'
      if (shouldFilterBeAlwaysVisible) {
        this.toggleFilters(null, false)
      }
      this.$selectedFiltersQty.removeClass('not_display')
      let selectedFiltersQty = 0
      const selectedFilters = this.collection.getFilter()
      if (selectedFilters) {
        selectedFiltersQty = Object.keys(selectedFilters).length
      }
      if (selectedFiltersQty === 0 && this.chosenFilters && this.chosenFilters.models.length) {
        selectedFiltersQty = this.chosenFilters.chosenFiltersQty
      }
      if (selectedFiltersQty) {
        this.$selectedFiltersQty.text(selectedFiltersQty)
      } else {
        this.$selectedFiltersQty.addClass('not_display')
      }
      this.$selectActionsToggle.removeClass('not_display')
      this.listenToOnce(this.chosenFilters, 'has-chosen-filters', this.updateFilterButton)
    }
  }

  /**
   * Переключение видимости фильтров
   * @param {Event|null} event - событие клика
   * @param {boolean} shouldFiltersHide - фильтры должны скрыться
   */
  toggleFilters (event, shouldFiltersHide) {
    if (event) {
      shouldFiltersHide = this.$toggleFiltersBtn.hasClass('filters-visible')
    }
    this.$toggleFiltersBtn
      .toggleClass('filters-visible', !shouldFiltersHide)
      .toggleClass('filters-hidden', shouldFiltersHide)
    this.$el.toggleClass('filters-hidden', shouldFiltersHide)
    Backbone.trigger('toggle-filter-block', shouldFiltersHide)
  }

  /**
   * Обновление состояния чекбокса выделения всех айтемов
   *
   * @param {boolean} state
   */
  updateCheckbox (state) {
    this.$('#c12345').prop('disabled', state)
  }

  /**
   * Вызывает событие для каталога.
   */
  wish () {
    this.trigger('add-checked-in-wish')
  }

  /**
   * Отключение кнопок на время прогрузки айтемов
   */
  disableButtons () {
    this.updateCheckbox(true)
    this.updateButtons(false)
  }

  /**
   * Вызывает событие для каталога.
   * @param {Event} e
   */
  removeChecked (e) {
    this.disableButtons()
    this.trigger('remove-checked', e)
    this.trigger('checkboxes-remove')
    this.toggleSelectActions(null, false)
  }

  /**
   * Добавление в корзину
   */
  addToCart () {
    this.disableButtons()
    this.trigger('add-checked-to-cart')
    this.trigger('checkboxes-remove')
    this.toggleSelectActions(null, false)
  }

  /**
   * Инициализация попапа
   */
  initPopup () {
    let that = this,
      popup = new Popup($('.js-checkbox-popup'), this.$('.js-checkbox-opener'), false, false)
    popup.addEventListener(
      Popup.EventType.BEFORE_OPEN,
      function () {
        let opener = that.$('.js-checkbox-opener'),
          top = opener.offset().top + opener.outerHeight() + 10,
          left = opener.parent().offset().left
        $('.js-checkbox-popup').css({
          left: left,
          top: top,
        })
      }
    )
  }
}
